import {
  SET_FORM_SELECTORS,
  SET_TABLE_DATA,
  SET_IS_LOADING,
  SET_REPORT_KINDS,
  RESET_STATE,
} from '../constants/reportStatus';

export const setFormSelectors = (payload) => ({
  type: SET_FORM_SELECTORS,
  payload,
});

export const setTableData = (payload) => ({
  type: SET_TABLE_DATA,
  payload,
});

export const setIsLoading = (payload) => ({
  type: SET_IS_LOADING,
  payload,
});

export const setReportKinds = (payload) => ({
  type: SET_REPORT_KINDS,
  payload,
});

export const resetState = () => ({
  type: RESET_STATE,
});
